import { CUSTOM_ELEMENTS_SCHEMA, AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, DestroyRef, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, Renderer2, ViewChild, inject } from '@angular/core';
import { CoBrandService } from 'src/app/core/services/co-brand.service';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { Config, disconnect, reconnect, switchChain } from '@wagmi/core';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { polygon } from 'viem/chains';
import { polygonAmoy } from './chains/polygonAmoy';

import { SocialAuthService } from '@abacritt/angularx-social-login';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Idle } from '@ng-idle/core';
import { createAppKit } from '@reown/appkit';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { mixpanelReset } from 'src/app/shared/utils/mixpanel.util';
import { ClipboardService } from 'ngx-clipboard';
import { Subject, Subscription, debounceTime, filter, firstValueFrom, take } from 'rxjs';
import { CustodialType } from 'src/app/shared/utils/common.interface';
import { CommonService } from 'src/app/shared/services/common.service';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { environment } from 'src/environments/environment';
import { getAddress } from 'viem';
import { getExplorerTransactionUrl } from 'src/app/shared/utils/explorer-url.util';
import { watchAccount, watchConnections } from 'wagmi/actions';
import { BID_FOCUS_NOTIFICATIONS, BORROWANDLEND, BORROWER_NOTIFICATIONS, BULK_OPEN_LOAN_OFFER_NOTIFICATION, COLLECTION_DELETED_MESSAGE_TYPE, COLLECTION_DELETED_PUSH_META, DEPOSIT_NOTIFICATIONS, FUND_NOTIFICATION, KYC_NOTIFICATION, LENDER_NOTIFICATIONS, LOAN_OFFER_FOCUS_NOTIFICATIONS, NotificationEvent, OTHER_NOTIFICATONS, PUSH_NOTIFICATION_META, PushNotificationItem, PushNotificationMeta, RESELLNOTIFICATION, SYNDICATELEND } from '../../constants/notification.const';
import { canAccessVerifiedUserApis, canWithdrawFunds, isAssetOnboardingRoute, isUserVerifiedAndValid, isVerificationBlockedUser } from '../../Helper/common-utils';
import { AccountService } from '../../services/account.service';
import { AnnouncementService } from '../../services/announcement.service';
import { HeightService } from '../../services/height.service';
import { NftService } from '../../services/nft.service';
import { NotificationService } from '../../services/notification.service';
import { SocketService } from '../../services/socket.service';
import { walletConfigService } from '../../services/wallet.service';
import { IApiResponse } from '../../utils/common.interface';
import { FilterSyncUrlHelper } from '../filters/filter-sync-url';
import { AppkitService, WalletState } from '../../services/appkit.service';
import { UserStateService } from '../../services/user-state.service';
import { CartService } from '../../services/cart.service';
import { AuthService as AppAuthService } from '../../services/auth.service';
import { UpdateService } from 'src/app/core/services/update.service';
import { UpdateBannerComponent } from 'src/app/module/update-banner/update-banner.component';
import { LoggerService } from '../../services/logger.service';
import { WalletStateService } from '../../services/wallet-state.service';
import { WalletAuthCoordinatorService } from '../../services/wallet-auth-coordinator.service';
import { ProfileMenuService, ProfileMenuAction } from '../../services/profile-menu.service';
import { decodeHtmlEntities } from '../../utils/html-sanitizer.util';
import { NgIf, NgStyle, NgClass, NgFor } from '@angular/common';
import { NoLeadingSpaceDirective } from '../../directives/no-leading-space.directive';
import { DepositCtaDirective } from '../../directives/deposit-cta.directive';
import { depositEntryParams } from '../../services/deposit-cta-analytics.service';
import { ExitQuestionService } from '../../services/exit-question.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { MailverficationComponent } from '../mailverfication/mailverfication.component';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { ProfileComponent } from '../profile/profile.component';
import { TransakModalComponent } from '../transak-modal/transak-modal.component';
import { MyCartComponent } from '../my-cart/my-cart.component';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { UiTerminologyPipe } from '../../pipes/ui-terminology.pipe';
import { WalletLabelPipe } from '../../pipes/wallet-label.pipe';

import { ImageFallbackDirective } from '../../directives/image-fallback.directive';
import { PinataThumbnailPipe } from 'src/app/shared/pipes/pinata-thumbnail.pipe';
import { AuthReturnUrlService } from '../../services/auth-return-url.service';
import { IntroducerOverview, IntroducerService } from '../../services/introducer.service';
dayjs.extend(relativeTime);

declare var bootstrap: any;

/** How often token balances refresh while the profile menu or USDC modal is open. */
const TOKEN_BALANCE_POLL_MS = 30_000;
/** Balance reads younger than this are reused, e.g. when the menu is closed and reopened. */
const BALANCE_CACHE_MS = 15_000;

@Component({
    selector: 'app-header-new',
    templateUrl: './header-new.component.html',
    styleUrls: ['./header-new.component.css'],
    animations: [
        trigger('fadeInOut', [
            // Slide in from right
            transition(':enter', [
                animate('500ms ease-in', keyframes([
                    style({ opacity: 0, transform: 'translateX(100%) scale(0.8)', offset: 0 }), // Start from outside right
                    style({ opacity: 0.5, transform: 'translateX(20%) scale(0.9)', offset: 0.5 }), // Midway point
                    style({ opacity: 1, transform: 'translateX(0) scale(1)', offset: 1 }) // Fully visible in place
                ]))
            ]),
            // Slide out to right
            transition(':leave', [
                animate('500ms ease-out', keyframes([
                    style({ opacity: 1, transform: 'translateX(0) scale(1)', offset: 0 }), // Start from current position
                    style({ opacity: 0.5, transform: 'translateX(20%) scale(0.9)', offset: 0.5 }), // Midway point
                    style({ opacity: 0, transform: 'translateX(100%) scale(0.8)', offset: 1 }) // Slide out to right and fade out
                ]))
            ])
        ])
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [PinataThumbnailPipe, ImageFallbackDirective, NgIf, NgStyle, RouterLink, NgClass, FormsModule, NoLeadingSpaceDirective, DepositCtaDirective, ReactiveFormsModule, NgFor, SpinnerComponent, ModalDirective, MailverficationComponent, PrivacyPolicyComponent, ProfileComponent, TransakModalComponent, MyCartComponent, SafeHtmlPipe, UiTerminologyPipe, WalletLabelPipe, UpdateBannerComponent]
})
export class HeaderNewComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
    /** Partner brand (logo, name) when the marketplace runs as a co-brand. */
    readonly coBrand = inject(CoBrandService);
    /** Exposed for the deposit CTA's `[queryParams]` — see `DepositCtaAnalyticsService`. */
    readonly depositEntryParams = depositEntryParams;
    private readonly destroyRef = inject(DestroyRef);
    private logoutInProgress = false;
    @ViewChild('verificationModal', { static: false }) verificationModal?: ModalDirective;
    @ViewChild('profileEditModel', { static: false }) profileEditModel?: ModalDirective;
    @ViewChild('switchNetworkModal', { static: false }) switchNetworkModal?: ModalDirective;
    @ViewChild('announcementContainer') announcementContainer!: ElementRef;
    @ViewChild('privacyPolicyModal', { static: false }) privacyPolicyModal?: ModalDirective;
    @ViewChild('transakModal', { static: false }) transakModal?: ModalDirective;
    @ViewChild('myCartModal', { static: false }) myCartModal?: ModalDirective;

    private resizeSubscription!: Subscription;
    @Output() contentHeightChange = new EventEmitter<number>();
    showProfile: boolean = false;
    showMenu = false;
    /** Policy document URLs (`privacy-policy_url`, `user-agreement_url`) for the profile menu's mobile legal links. */
    docUrl: Record<string, string | null> | null = null;
    @ViewChild('navbarCollapse') navbarCollapse!: ElementRef;
    @ViewChild('profileDropdownToggle') profileDropdownToggle?: ElementRef;
    @ViewChild('profileDropdownToggleMobile') profileDropdownToggleMobile?: ElementRef;
    @ViewChild('searchContainer') searchContainer?: ElementRef;
    modalConfig: ModalOptions = {
        animated: true,
        keyboard: false,
        backdrop: 'static',
        ignoreBackdropClick: true
    };
    regulated: boolean = true;
    web3Modal: any;
    unwatchAccount: any;
    unwatchNetwork: any;
    account: any = { walletAddress: "", chainId: "", walletProvider: "", networkId: "", init: true };
    pendingAccount: any = null;
    /** Whether the "Incorrect Network." switch button can act: any connected wallet, whatever its type. */
    canSwitchNetwork: boolean = false;
    user: any;
    /** Profile-menu entry to Introducer earnings; only set for a user who has introduced someone. */
    introducerOverview: IntroducerOverview | null = null;
    private readonly introducerService = inject(IntroducerService);
    private readonly exitQuestionService = inject(ExitQuestionService);
    connectObservable: any;
    authenticationObservable: any;
    clicked: any;
    regulatedBalance: number = 0;
    maticPrice: number = 0;
    public loaderStatus: boolean = true;
    public loaderObservable: any;
    searchKeyword: string = "";
    searchKeywordObservable: any;
    nftCount: number = 0;
    currencies: any[] = [];
    defaultNetwork: string = 'null'
    notifications: any[] = [];
    notificationCount: number = 0;
    notificationPage: number = 1;
    notificationLimit: number = 10;
    // Page size / page cap used only when gathering unread ids for "Read all".
    private readonly READ_ALL_FETCH_LIMIT: number = 100;
    private readonly READ_ALL_MAX_PAGES: number = 50;
    hasMoreNotifications: boolean = true;
    isNotificationLoadingMore: boolean = false;
    kycStatus: any = {};
    hasUnreadNotifications: boolean = false;
    isNotificationLoader = false;
    recentSearch: Array<any> = [];
    isSearch = false;
    searchControl = new FormControl({ value: '', disabled: true });
    private unsubscribeSearch$ = new Subject<void>();
    isSearchLoading = false;
    isNotification: boolean = false;
    notification: any = {};
    // Single-banner state, replaced by the pushNotifications stack below.
    // // Card meta (title / status pill / action) for the push banner; null keeps the legacy banner.
    // pushNotificationMeta: PushNotificationMeta | null = null;
    // Fixed `top` for the push card: 20px under the header's bottom edge, so it overlays the
    // page's top action row (Share / status badge). null falls back to the CSS `top`.
    pushCardTop: number | null = null;
    // // Auto-hide timer for the push banner; cleared when a newer notification replaces it.
    // private pushNotificationTimeout: ReturnType<typeof setTimeout> | null = null;
    // Push notifications on screen, oldest first (max MAX_VISIBLE_PUSH_NOTIFICATIONS); each
    // carries its own 5s auto-hide timer. Later arrivals wait in the queue, in arrival order.
    pushNotifications: PushNotificationItem[] = [];
    private pushNotificationQueue: PushNotificationItem[] = [];
    private pushNotificationKey = 0;
    // private readonly MAX_VISIBLE_PUSH_NOTIFICATIONS = 3;
    // Strictly one card at a time; everything else waits in pushNotificationQueue, in arrival order.
    private readonly MAX_VISIBLE_PUSH_NOTIFICATIONS = 1;
    // Matches the 5s `push-card-timer` animation in the CSS; change both together.
    private readonly PUSH_NOTIFICATION_DURATION = 5000;
    // Shorter auto-hide for a card shown while others are queued behind it, so a burst
    // (e.g. bulk loan offers) clears in reasonable time instead of 5.5s per card.
    private readonly PUSH_NOTIFICATION_BACKLOG_DURATION = 3000;
    // Matches the 500ms `:leave` of the fadeInOut animation above; change both together.
    private readonly PUSH_NOTIFICATION_LEAVE_DURATION = 500;
    // Set while a closed card is still sliding out, so the next one waits until it has fully gone.
    private pushNotificationLeaveTimeout: ReturnType<typeof setTimeout> | null = null;
    // Hover-to-pause only where a real hover exists; a tap on touch screens fires mouseenter
    // without a reliable mouseleave, which would leave the card stuck open.
    private readonly canHoverPushNotification = typeof window !== 'undefined' && !!window.matchMedia?.('(hover: hover)').matches;
    // Items this user won a bid on (BID_APPROVED), keyed by item, with when it was approved. On accept
    // the backend also sends BID_CANCELLED_DUE_TO_OTHER_ACCEPTANCE for the winner's own bid, so the winner
    // would get "Bid approved" and "Bid closed" together. A user holds one open bid per item, so a
    // "Bid closed" for an item they just won is always that echo and is dropped. Matched by item, not
    // bid id, because the bid ids on the two payloads were not reliably equal. Other bidders never get
    // BID_APPROVED for that item, so their "Bid closed" still shows.
    private acceptedBidItems = new Map<string, number>();
    // Both notifications come from one accept request; the window stops a much later, genuine
    // "Bid closed" on the same item (a fresh bid after it was resold) from being dropped.
    private readonly ACCEPTED_BID_ECHO_WINDOW = 2 * 60 * 1000;
    isExpand: boolean = false;
    announceData: any = {}
    private resizeObserver: ResizeObserver | null = null;
    private custodialType = CustodialType;
    showMailVerificationMenu = true;
    profileurl: any;
    profileLoader: boolean = false
    userDetails: any;
    privacyPolicyStatus: boolean = false;
    onboardPage: any;
    cartDetails: any;
    cartCount: number = 0;
    private tokenBalanceInterval: any = null;
    private tokenBalanceFetch: Promise<void> | null = null;
    private tokenBalanceRefreshQueued = false;
    private tokenBalanceFetchedAt = 0;
    private tokenBalanceFetchKey = '';
    private nativeBalanceFetch: Promise<void> | null = null;
    private nativeBalanceFetchedAt = 0;
    private nativeBalanceFetchKey = '';
    private isUsdcModalOpen = false;
    usdcModalInitialTab: 'add' | 'withdraw' = 'add';
    private readonly popStateHandler = () => {
        if (this.routerCheck) {
            this.searchKeyword = '';
        }
    };

     get canShowWithdrawButton(): boolean {
        return canWithdrawFunds(this.user, this.getStoredRegulatedMode());
    }

    private getStoredRegulatedMode(): boolean {
        try {
            const rawValue = window.sessionStorage.getItem('rw.regulatedMode');
            const normalizedValue = rawValue?.trim().toLowerCase();

            switch (normalizedValue) {
                case 'true':
                case '"true"':
                case '1':
                    return true;
                case 'false':
                case '"false"':
                case '0':
                    return false;
            }
        } catch {
            // Ignore storage access issues and fall back to the in-memory state.
        }

        return this.walletStateService.getRegulated();
    }

   

    /**
     * constructor
     */
    constructor(
        private webStorageService: WebStorageService,
        public router: Router,
        public route: ActivatedRoute,
        private toastr: ToastrService,
        public commonService: CommonService,
        private accountService: AccountService,
        private nftService: NftService,
        private clipboardService: ClipboardService,
        private socketService: SocketService,
        private cdref: ChangeDetectorRef,
        private notificationService: NotificationService,
        private elementRef: ElementRef,
        private authService: SocialAuthService,
        private announce: AnnouncementService,
        private idle: Idle,
        private renderer: Renderer2,
        private heightService: HeightService,
        private filterSyncUrlHelper: FilterSyncUrlHelper,
        private titleService: Title,
        private walletConfigService: walletConfigService,
        private appkitService: AppkitService,
        private userState: UserStateService,
        private cartService: CartService,
        private appAuthService: AppAuthService,
        private logger: LoggerService,
        private walletStateService: WalletStateService,
        private profileMenuService: ProfileMenuService,
        private walletAuthCoordinator: WalletAuthCoordinatorService,
        private updateService: UpdateService,
        private authReturnUrl: AuthReturnUrlService
    ) {
    }

    async ngOnInit() {
        this.profileMenuService.openProfileMenu$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((options) => this.openProfileMenuFromDashboard(options));

        // The footer carries the legal links but is hidden on phones (styles.css, max-width 575px),
        // so the profile menu repeats them there. getDocument() is shareReplay-cached in CommonService.
        this.commonService.getDocument()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (docUrls) => { this.docUrl = docUrls; },
                error: (err) => this.logger.warn('Failed to load policy document URLs', err)
            });

        // The update strip renders inside #announcementContainer, whose height is
        // PINNED by updateAnnouncementHeight(). A pinned box does not change size
        // when content appears inside it, so the ResizeObserver never fires — the
        // strip would be clipped and the page would not shift. Re-measure in a
        // macrotask so the strip has rendered first.
        this.updateService.updateAvailable$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((available) => {
                if (!available) { return; }
                setTimeout(() => {
                    this.updateAnnouncementHeight();
                    this.cdref.detectChanges();
                });
            });

        this.profileMenuService.openWithdrawalMenu$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.openWithdrawFundModal());

        this.commonService.usdcModalTrigger$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((request) => {
                if (!request) {
                    return;
                }

                if (request.tab === 'withdraw') {
                    void this.openWithdrawFundModal();
                    return;
                }

                this.openTransakModal();
            });

        // Regulated state (boolean)
        this.userState.regulated$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.regulated = this.walletStateService.getRegulated();
        });
        // Listen the wallet network regardless of the initial regulated value.
        // On refresh, the non-custodial flag may flip to false only after the
        // connector state is restored.
        this.appkitService.walletState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((state: WalletState) => {
            this.canSwitchNetwork = state.connected;
            if (!this.regulated) {
                if (!state.connected || !state.walletAddress) {
                    this.handleWalletDisconnectState();
                } else {
                    this.logger.debug('Header wallet connected state updated', { connected: true, chainId: state.chainId, hasWalletAddress: !!state.walletAddress });
                    if (!state.unsupportedChain) {
                        let { walletAddress } = state;
                        if (this.shouldBlockWalletAutoAuth(walletAddress)) {
                            this.pendingAccount = null;
                            return;
                        }
                        let { chainId, networkId } = this.commonService.getNetwork(String(state.chainId));
                        if (walletAddress !== this.account?.walletAddress || chainId !== this.account?.chainId) {
                            this.pendingAccount = { walletAddress: getAddress(walletAddress), chainId, walletProvider: state.walletProvider, networkId };
                            this.checkUserRegistration(walletAddress);
                            this.switchNetworkModal?.hide();
                            this.commonService.closeAllModals(false);
                        }
                    } else {
                        this.pendingAccount = null;
                        if (state.unsupportedChain) {
                            this.commonService.closeAllModals(true);
                            this.switchNetworkModal?.show();
                        }
                    }
                }
            }
            this.logger.debug('Header wallet state changed', { connected: state.connected, unsupportedChain: state.unsupportedChain, chainId: state.chainId });
        });
        this.titleService.setTitle('RealWorld.fi')
        this.browserBackButtonEvent(1)
        this.getAdminAnnouncement();
        this.defaultNetwork = environment.DEFAULT_NETWORK;
        this.loaderObservable = this.accountService.loaderStatus.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
            this.loaderStatus = response;
            response ? this.searchControl.disable() : this.searchControl.enable();
            this.cdref.detectChanges();
        })
        this.connectObservable = this.accountService.connectObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {
            if (response) {
                this.web3Modal?.open();
            }
        })


        // Account state - trust the state service, don't fall back to localStorage
        this.userState.account$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(acc => {
            // Always use the state service value, even if null/undefined
            const previousKey = this.walletBalanceKey();
            this.account = acc !== null && acc !== undefined ? acc : { walletAddress: "", chainId: "", walletProvider: "", networkId: "", init: true };
            // A different wallet or network makes every cached balance stale. The cache keys
            // already miss on their own; this refreshes an open menu right away instead of
            // leaving the old wallet's figures on screen until the next poll.
            if (previousKey !== this.walletBalanceKey() && this.isBalancePollingWanted()) {
                void this.getBalance(true);
                void this.getTokenBalance(true);
            }
        });
        this.userState.user$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(user => {
            // Always use the state service value, even if null/undefined
            this.user = user !== null && user !== undefined ? user : undefined;
            this.syncVerificationModalState(this.user);
            if (this.user) {
                this.privacyPolicyStatus = !this.user?.is_policy_accepted
                if (!this.canLoadVerifiedUserData(this.user)) {
                    this.resetVerifiedUserScopedUi();
                    return;
                }
                this.socketService.connect();
                this.profileurl = this.user?.['profile_image'] as string | undefined;
                this.userDetails = this.user;
                this.getNotifications();
                this.getCartDetails();
                this.getIntroducerOverview();
                this.commonService.isPolicyUpdatedUser(this.user, this.privacyPolicyModal);
            } else {
                this.introducerOverview = null;
            }
        });

        // this.router.navigate(['/dashboard']);
        if (this.user && !this.user?.name) {
            let emailSplit = (this.user.email)?.split('@');
            this.user.name = emailSplit?.[0];
        }

        if (this.user) {
            this.privacyPolicyStatus = !this.user?.is_policy_accepted
            if (this.canLoadVerifiedUserData(this.user)) {
                this.profileurl = this.user?.['profile_image'] as string | undefined;
                this.userDetails = this.user;
                this.commonService.isPolicyUpdatedUser(this.user, this.privacyPolicyModal);
            } else {
                this.resetVerifiedUserScopedUi();
            }
        }
        this.searchControl.valueChanges
            .pipe(
                debounceTime(2000),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe((value: any) => {
                if (this.searchKeyword != value) this.search(value!);
            });
        this.searchKeywordObservable = this.nftService.searchKeywordObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (response: any) => {
            let searchValue = ''
            await this.handleSearchValue(this.router.url.toString(), (search: string) => {
                searchValue = search
                if (response || searchValue) {
                    this.searchControl.setValue(response ? response : searchValue)
                } else {
                    this.searchKeyword = '';
                    this.searchControl.setValue('')
                }
            })


        })
        if (!this.user) {
            this.handleOauthState()
        } else this._handleGoogleOneTapClose()


        if (this.user && this.canLoadVerifiedUserData(this.user)) {
            this.socketService.connect();
        }



        // Using router events to trigger code on every route change
        this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef)).subscribe(async (data) => {
            this.onboardPage = isAssetOnboardingRoute(data.url);
            this.syncVerificationModalState();
            // A link inside the profile panel navigates without closing it, which
            // left the next page sitting under the backdrop. Close the panel on
            // every route change (back/forward included) so the new screen always
            // starts clean. closeProfile() also hides the Bootstrap dropdown, which
            // resetting `showProfile` alone leaves open.
            this.closeProfile();
            // if (data.url.includes('?regulated=')) {
            //     let urlSplit = data.url.split('?regulated=');
            //     let regulation = urlSplit[urlSplit.length - 1].includes('&') ? urlSplit[urlSplit.length - 1].split('&')[0] : urlSplit[urlSplit.length - 1];
            //     let regulationBoolean = (regulation === 'true');

            //     //We Are Now Using the Same Nft for the Both Platform So the below condition not need 
            //     // if (this.regulated != regulationBoolean) {
            //     //     this.regulated = regulationBoolean;
            //     //     await this.webStorageService.setLocalStorage('regulated', this.regulated);
            //     //     disconnect();
            //     //     this.webStorageService.clearItem();
            //     //     this.user = undefined;
            //     //     this.account = { walletAddress: "", chainId: "", walletProvider: "", networkId: "", init: true };
            //     //     this.switchNetworkModal?.hide();
            //     //     this.notificationCount = 0;
            //     //     this.notifications = [];
            //     // }
            // } else {
            //     // regulated / unreguated
            //     this.regulated = this.walletStateService.getRegulated();
            //     await this.webStorageService.setLocalStorage('regulated', this.regulated);
            // }
            if (this.regulated == false) {
                // wallet connect
                // this.web3Modal = createWeb3Modal({ wagmiConfig, projectId, chains, themeVariables: { '--w3m-accent': '#006736', '--w3m-z-index': 10000, '--w3m-font-family': 'Source Code Pro', '--w3m-font-size-master': 'sm' } })
            } else {
                this.getBalance();
            }

            // On initial login the one-time getCurrencies() below runs while the
            // app is still on /sign-in (auth resolves before navigation), so its
            // url-guard skips it and the currency list / Add USDC stay hidden
            // until a manual refresh. Re-assert the load here once the user lands
            // on an authenticated page; the !currencies guard avoids redundant calls.
            if (this.user?._id && this.canLoadVerifiedUserData(this.user)
                && this.router.url !== '/sign-in' && this.router.url !== '/sign-up'
                && !this.currencies?.length) {
                this.getCurrencies();
            }
        });
        if (this.user?._id && this.canLoadVerifiedUserData(this.user) && this.router.url != '/sign-in' && this.router.url != '/sign-up') {
            // Load currencies for every authenticated, verified user.
            // Previously gated on `regulated`, which hid the currency block
            // for self-custody users. See fix/header-currency-block-gating.
            this.getCurrencies();
        }

        if (this.user?._id && this.canLoadVerifiedUserData(this.user)) {
            // Load notifications & cart once
            this.getNotifications();
            this.getCartDetails();
        }

        // Notification Listener — registered unconditionally, like the KYC listener below.
        // Signing in navigates by router rather than reloading, so the header's ngOnInit has
        // already run (with no user) by the time a session exists; registering this inside the
        // canLoadVerifiedUserData branch meant a freshly signed-in user got no push banner at
        // all until they hard-refreshed, even though the bell list kept filling in over HTTP.
        // The eligibility check moves into the handler, where it is re-evaluated per event.
        this.socketService.getNotification()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((notification: any) => this.handleIncomingNotification(notification));

        // Cart Update Listener
        this.cartService.cartUpdated$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((updated: boolean) => {
                if (updated && this.user?._id && this.canLoadVerifiedUserData(this.user)) {
                    this.getCartDetails();
                }
            });

        // KYC status Listener — refresh the badge/profile state live when verification
        // completes, instead of only on profile-menu open. Registered outside the
        // canLoadVerifiedUserData branch so a user who becomes eligible mid-session
        // (e.g. completes their profile, then verifies) still gets live updates.
        this.socketService.getKycStatusUpdate()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.accountService.clearKycStatusCache();
                this.getKycStatus();
            });

        this.accountService.updateAuthentication(true);
        this.authenticationObservable = this.accountService.authenticationObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {
            if (!response && !this.logoutInProgress) {
                this.logout(true);
            }
        })
        this.user?._id && this.canLoadVerifiedUserData(this.user) && this.getRecentSearch();
        this.nftService.recentSearchObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
            if (response) {
                this.user?._id && this.canLoadVerifiedUserData(this.user) && this.getRecentSearch();
                setTimeout(() => {
                    this.nftService.recentSearchStatus(false);
                }, 1000);
            }

        })
        this.setupResizeObserver();
        this.setCustodialType();
        isUserVerifiedAndValid(this.user, this.verificationModal, this.regulated);

    }

    /**
     * Handles incoming notifications from the server and updates the UI accordingly.
     * @param notification The incoming notification object.
     */
    private handleIncomingNotification(notification: any) {
        if (!notification) return;
        // Checked per event rather than at subscription time: a user who signs in — or who
        // becomes eligible — mid-session must start receiving banners without a reload.
        if (!this.user?._id || !this.canLoadVerifiedUserData(this.user)) return;

        // The winning bidder gets only "Bid approved"; their own "Bid closed" is skipped.
        if (notification.event_type === NotificationEvent.BID_APPROVED) {
            this.rememberAcceptedBid(notification);
            // Backend sends approved first, but drop a "Bid closed" that beat it here too.
            this.removeOwnBidClosedNotifications();
        } else if (this.isOwnBidClosedNotification(notification)) {
            return;
        }

        notification.timeDiff = dayjs(notification.createdAt).from(dayjs());
        notification.updateData = notification?.updateData;
        notification.image = notification?.updateData?.image;

        // Add to list
        this.notifications.unshift(notification);

        // Update counters
        this.notificationCount++;
        this.notification = notification;
        // this.pushNotificationMeta = PUSH_NOTIFICATION_META[notification?.event_type as NotificationEvent] ?? null;
        // The card is a sibling of `.header.fixed-top`, not a child, so its position has to be
        // measured; the header is fixed, so its bottom edge doesn't move with page scroll.
        const headerEl = (this.elementRef.nativeElement as HTMLElement).querySelector('.header.fixed-top');
        this.pushCardTop = headerEl ? Math.round(headerEl.getBoundingClientRect().bottom) + 20 : null;

        // Update unread status
        this.checkUnreadNotifications();

        // Show push notification
        this.isNotification = true;

        // Auto-hide after 5 sec
        // setTimeout(() => this.closePushnotification(), 5000);
        // Restart the 5s window for each notification; the previous timer would otherwise
        // close a newer banner early.
        // if (this.pushNotificationTimeout) clearTimeout(this.pushNotificationTimeout);
        // this.pushNotificationTimeout = setTimeout(() => this.closePushnotification(), 5000);

        // Queue order: show it now if a slot is free, otherwise wait for the oldest card to close.
        const push: PushNotificationItem = {
            key: ++this.pushNotificationKey,
            notification,
            // meta: PUSH_NOTIFICATION_META[notification?.event_type as NotificationEvent] ?? null,
            meta: this.getPushNotificationMeta(notification),
            timeout: null,
            // Both are set again in displayPushNotification, once the backlog at show time is known.
            duration: this.PUSH_NOTIFICATION_DURATION,
            remaining: this.PUSH_NOTIFICATION_DURATION,
            startedAt: 0,
            canRedirect: this.canRedirectPushNotification(notification),
        };
        // if (this.pushNotifications.length < this.MAX_VISIBLE_PUSH_NOTIFICATIONS) {
        // Also wait while the previous card is still leaving, and behind anything already queued.
        if (this.pushNotifications.length < this.MAX_VISIBLE_PUSH_NOTIFICATIONS && !this.pushNotificationLeaveTimeout && !this.pushNotificationQueue.length) {
            this.displayPushNotification(push);
        } else {
            this.pushNotificationQueue.push(push);
        }
    }

    /**
     * Item a sale-bid notification is about. BID_APPROVED and BID_CANCELLED_DUE_TO_OTHER_ACCEPTANCE
     * build `updateData` the same way: `id` for lazy-minted items, collection + token otherwise.
     */
    private getBidNotificationItemKey(notification: any): string | null {
        const updateData = notification?.updateData;
        if (!updateData) return null;
        if (updateData.id) return String(updateData.id);
        if (updateData.collection_address && updateData.token_id !== undefined && updateData.token_id !== null) {
            return `${String(updateData.collection_address).toLowerCase()}_${updateData.token_id}`;
        }
        return null;
    }

    private getNotificationTime(notification: any): number {
        const time = new Date(notification?.createdAt).getTime();
        return Number.isNaN(time) ? Date.now() : time;
    }

    private rememberAcceptedBid(notification: any) {
        const itemKey = this.getBidNotificationItemKey(notification);
        if (itemKey) this.acceptedBidItems.set(itemKey, this.getNotificationTime(notification));
    }

    /** A "Bid closed" for an item this user won a bid on, from the same accept. */
    private isOwnBidClosedNotification(notification: any): boolean {
        if (notification?.event_type !== NotificationEvent.BID_CANCELLED_DUE_TO_OTHER_ACCEPTANCE) return false;
        const itemKey = this.getBidNotificationItemKey(notification);
        const approvedAt = itemKey ? this.acceptedBidItems.get(itemKey) : undefined;
        return approvedAt !== undefined && Math.abs(this.getNotificationTime(notification) - approvedAt) <= this.ACCEPTED_BID_ECHO_WINDOW;
    }

    /** Takes the winner's own "Bid closed" off the stack, the queue and the bell list. */
    private removeOwnBidClosedNotifications() {
        this.pushNotifications.filter((push) => this.isOwnBidClosedNotification(push.notification)).forEach((push) => this.closePushnotification(push));
        this.pushNotificationQueue = this.pushNotificationQueue.filter((push) => !this.isOwnBidClosedNotification(push.notification));

        const hidden = this.notifications.filter((item: any) => this.isOwnBidClosedNotification(item));
        if (!hidden.length) return;
        this.notifications = this.notifications.filter((item: any) => !this.isOwnBidClosedNotification(item));
        this.notificationCount = Math.max(0, this.notificationCount - hidden.filter((item: any) => item.read === 0).length);
        this.checkUnreadNotifications();
    }

    /**
     * Same rule for rows loaded from the API: the winner's own "Bid closed" is left out, and the
     * unread count drops by the hidden unread rows. `loaded` is the list already shown, so a
     * "Bid approved" on an earlier page still pairs with a "Bid closed" on this one.
     */
    private filterOwnBidClosedNotifications(results: any[], loaded: any[] = []): any[] {
        [...loaded, ...results]
            .filter((item: any) => item?.event_type === NotificationEvent.BID_APPROVED)
            .forEach((item: any) => this.rememberAcceptedBid(item));

        let hiddenUnread = 0;
        const kept = results.filter((item: any) => {
            const isOwnBidClosed = this.isOwnBidClosedNotification(item);
            if (isOwnBidClosed && item.read === 0) hiddenUnread++;
            return !isOwnBidClosed;
        });
        this.notificationCount = Math.max(0, this.notificationCount - hiddenUnread);
        return kept;
    }

    /** Adds a push notification to the bottom of the stack and starts its own 5s auto-hide. */
    private displayPushNotification(push: PushNotificationItem) {
        // Anything still waiting behind this card shortens its time on screen.
        push.duration = this.pushNotificationQueue.length ? this.PUSH_NOTIFICATION_BACKLOG_DURATION : this.PUSH_NOTIFICATION_DURATION;
        push.remaining = push.duration;
        this.pushNotifications = [...this.pushNotifications, push];
        // push.timeout = setTimeout(() => this.closePushnotification(push), 5000);
        this.startPushNotificationTimer(push);
    }

    /** Counts down whatever auto-hide time the card has left. */
    private startPushNotificationTimer(push: PushNotificationItem) {
        push.startedAt = Date.now();
        push.timeout = setTimeout(() => this.closePushnotification(push), push.remaining);
    }

    /** Hovering a card holds it open; the CSS pauses its timer bar on :hover to match. */
    pausePushNotification(push: PushNotificationItem) {
        if (!this.canHoverPushNotification || !push.timeout) return;
        clearTimeout(push.timeout);
        push.timeout = null;
        push.remaining = Math.max(0, push.remaining - (Date.now() - push.startedAt));
    }

    /**
     * Whether clicking the push card can open a real page. Needs the saved notification's `_id`
     * (readNotification marks it read by id; the cron's event-49 payload has none), an event that
     * redirectNotifications handles, and a target in updateData — events 23/32/38/52/54 arrive
     * without one and would otherwise navigate to an `undefined` URL.
     */
    private canRedirectPushNotification(notification: any): boolean {
        const eventType = notification?.event_type;
        // const updateData = notification?.updateData ?? {};
        const isHandled = [
            ...KYC_NOTIFICATION, ...DEPOSIT_NOTIFICATIONS, ...OTHER_NOTIFICATONS, ...BORROWER_NOTIFICATIONS,
            ...LENDER_NOTIFICATIONS, ...BULK_OPEN_LOAN_OFFER_NOTIFICATION, ...FUND_NOTIFICATION,
            ...BORROWANDLEND, ...SYNDICATELEND, ...RESELLNOTIFICATION, NotificationEvent.LOAN_LENDER_CHANGED,
        ].includes(eventType);
        // const hasTarget = !!(updateData.id || updateData.loan_id || (updateData.collection_address && updateData.token_id));
        const hasTarget = this.hasNotificationTarget(notification);
        return !!notification?._id && isHandled && hasTarget;
    }

    /**
     * Whether the notification's updateData names somewhere to go. Shared by the push card and the
     * bell row (redirectNotifications), which used to navigate to an `undefined` URL without one.
     */
    private hasNotificationTarget(notification: any): boolean {
        const updateData = notification?.updateData ?? {};
        return !!(updateData.id || updateData.loan_id || (updateData.collection_address && updateData.token_id));
    }

    /**
     * Card meta for a push notification; null keeps the legacy banner. The admin collection-delete
     * payload has no event_type, so it is matched by message_type instead.
     */
    private getPushNotificationMeta(notification: any): PushNotificationMeta | null {
        const meta = PUSH_NOTIFICATION_META[notification?.event_type as NotificationEvent];
        if (meta) return meta;
        return notification?.message_type === COLLECTION_DELETED_MESSAGE_TYPE ? COLLECTION_DELETED_PUSH_META : null;
    }

    /** Click on a push card: close it and open the same page as clicking its bell row. */
    openPushNotification(push: PushNotificationItem) {
        if (!push.canRedirect) return;
        this.closePushnotification(push);
        this.readNotification(push.notification);
    }

    /** Leaving the card resumes it with the time it had left, not a fresh 5s. */
    resumePushNotification(push: PushNotificationItem) {
        if (!this.canHoverPushNotification || push.timeout || !this.pushNotifications.includes(push)) return;
        this.startPushNotificationTimer(push);
    }

    trackPushNotification(_index: number, push: PushNotificationItem) {
        return push.key;
    }


    async ngAfterViewInit() {
        // Handles an edge case where a wallet connects without user data in Local Storage 
        // (e.g., due to a reload interruption). For custodial wallets, triggers disconnection 
        // to prevent an invalid authenticated state.
        if (!this.regulated && !this.user && this.account?.walletAddress) {
            await disconnect(this.appkitService.adapter?.wagmiConfig);
        }

        this.syncVerificationModalState();
    }

    setCustodialType() {
        this.commonService.custodialTypeObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (response: string) => {
            if (response.length && response === this.custodialType.custodial) {
                this.regulated = true;
                this.walletStateService.setRegulated(this.regulated);
                this.logout();
            } else if (response === this.custodialType.nonCustodial) {
                this.regulated = false;
                this.walletStateService.setRegulated(this.regulated);
                this.logout();
            }


        })
    }

    ngAfterViewChecked() {
        this.updateAnnouncementHeight();
    }


    updateAnnouncementHeight() {
        if (this.announcementContainer) {
            const element = this.announcementContainer.nativeElement as HTMLElement;

            // Temporarily remove any height constraint
            this.renderer.setStyle(element, 'height', 'auto');

            // Force a reflow
            void element.offsetHeight;

            // Get the natural height of the content
            const contentHeight = element.scrollHeight;

            // Set the height
            this.renderer.setStyle(element, 'height', `${contentHeight}px`);

            // Update the HeightService with the new height
            this.heightService.setHeaderHeight(contentHeight);

        } else {
            // if announcement bar is disabled in the dapp, this will get called
            this.heightService.setHeaderHeight(0);

        }
    }


    /**
     * Refreshes the native (POL) balance. Reuses a read younger than BALANCE_CACHE_MS for the
     * same wallet + network unless `force` is set, and shares a read that is still in flight.
     */
    async getBalance(force = false): Promise<void> {
        if (!this.account?.walletAddress) { return; }
        if (this.nativeBalanceFetch) { return this.nativeBalanceFetch; }
        const key = this.walletBalanceKey();
        if (!force && key === this.nativeBalanceFetchKey && Date.now() - this.nativeBalanceFetchedAt < BALANCE_CACHE_MS) {
            return;
        }

        this.nativeBalanceFetch = (async () => {
            try {
                const balance = await this.commonService.getNativeBalance(this.account);
                // The wallet or network changed mid-read: this result belongs to the old one.
                if (key !== this.walletBalanceKey()) { return; }
                this.regulatedBalance = Number(balance.formatted);
                this.nativeBalanceFetchKey = key;
                this.nativeBalanceFetchedAt = Date.now();
            } catch (error) {
                this.logger.warn('Failed to read native balance for header', error);
            } finally {
                this.nativeBalanceFetch = null;
            }
        })();
        return this.nativeBalanceFetch;
    }

    public toggleMenu(event: MouseEvent) {
        event.stopPropagation();
        this.showMenu = !this.showMenu;
    }

    /**
     * Notifications only ever arrive live through this tab's own socket connection. A tab left
     * in the background can have that socket silently die (an expired session cookie by the
     * time of a later reconnect attempt, a network blip that outlasts socket.io's own retry
     * window) without anything in the UI signalling it - the bell badge just stops updating,
     * and the freeze/unfreeze notification (or any other) only shows up once a full page
     * reload calls connect() again from scratch. Re-running the same eligibility-gated
     * connect() (a no-op if the socket is already healthy - see its own early-return) on
     * refocus, plus a fresh HTTP pull to backfill anything missed while it was down, gets the
     * same result as a refresh without needing one.
     */
    @HostListener('document:visibilitychange')
    onVisibilityChange(): void {
        if (document.visibilityState !== 'visible') return;
        // Polling skips hidden tabs; catch up as soon as the menu is visible again.
        if (this.tokenBalanceInterval) { void this.getTokenBalance(); }
        if (!this.user?._id || !this.canLoadVerifiedUserData(this.user)) return;
        this.socketService.connect();
        this.getNotifications();
    }

    @HostListener('window:click', ['$event'])
    onClick(event: MouseEvent) {
        const targetElement = this.navbarCollapse?.nativeElement;

        if (targetElement && event.target) {
            const clickedInside = targetElement.contains(event.target as Node);

            if (!clickedInside) {
                this.showMenu = false;
            }
        }
    }

    async slideToggle() {
        this.regulated = !this.regulated;
        this.walletStateService.setRegulated(this.regulated);
        this.filterSyncUrlHelper.getAppliedFilterQueries('all');
        this.logout();
        if (this.regulated == false) {
            // Listen the wallet network
            this.setListnerConnectWallet()
        }
    }

    setAccount = async () => {
        let store: any = this.walletStateService.getWagmiStore();
        let isConnected: any = this.walletStateService.getWagmiConnected();
        if (!isConnected) {
            return;
        }
        if (isConnected) {
            let provider: any = this.walletStateService.getRecentConnectorId();
            if (store && store.state?.data && !store.state?.data?.chain.unsupported) {
                let { account, chain } = store?.state.data;
                if (this.shouldBlockWalletAutoAuth(account)) {
                    this.pendingAccount = null;
                    return;
                }
                // this.router.navigate(['/dashboard']);
                let { chainId, networkId } = await this.commonService.getNetwork((chain.id).toString());
                if (account !== this.account?.walletAddress || chainId !== this.account?.chainId) {
                    this.pendingAccount = { walletAddress: getAddress(account), chainId, walletProvider: provider === 'io.metamask' ? 'metamask' : 'walletconnect', networkId };
                    this.checkUserRegistration(account);
                    this.switchNetworkModal?.hide();
                    this.commonService.closeAllModals(false);
                }
            } else {
                this.pendingAccount = null;
                if (store?.state?.data?.chain.unsupported) {
                    this.commonService.closeAllModals(true);
                    this.switchNetworkModal?.show();
                }
            }
        }
    }

    async logout(authFailed: Boolean = false) {
        if (this.logoutInProgress) {
            return;
        }

        this.logoutInProgress = true;
        // Before the redirect below: leaving a flow because of a sign-out does not ask the exit question.
        this.exitQuestionService.endSession();
        this.pendingAccount = null;
        if (!this.regulated) {
            this.walletStateService.requireExplicitWalletReconnect();
        }
        const walletAddress = this.user?.wallet_address;
        // Mark new items as old (fire & forget)
        if (walletAddress) {
            this.commonService
                .markNewItemAsOld(walletAddress)
                .subscribe({
                    error: () => { } // silent fail
                });
        }
        this.user = undefined;
        try {
            await disconnect(this.appkitService.adapter?.wagmiConfig);
        } catch (error) {
            // Connector may already be disconnected — treat as non-fatal
            // Logout must complete regardless of connector state
            this.logger.warn('Wallet disconnect threw during logout', error);
        }
        this.account = { walletAddress: "", chainId: "", walletProvider: "", networkId: "", init: true };
        this.switchNetworkModal?.hide();
        mixpanelReset();
        this.idle.stop();
        this.redirectToHome(authFailed);
        this.socketService.disconnect();
        this.notificationCount = 0;
        this.notifications = [];
        this.accountService.updateAuthentication(false);
        this.appAuthService.logout({ manual: !authFailed, showToast: !authFailed, broadcast: !authFailed }).subscribe({
            next: () => {
                this.authService?.signOut(true).catch(() => undefined);
            },
            error: () => {
                this.authService?.signOut(true).catch(() => undefined);
            },
            complete: () => {
                this.logoutInProgress = false;
                this.removeOverlay();
                // A manual sign-out is not a "Log in" click: the page left behind must not
                // become the destination of the next sign-in, which uses its default page.
                void this.router.navigate(['/sign-in']).then(() => {
                    if (!authFailed) {
                        this.authReturnUrl.forget();
                    }
                });
            }
        });
    }

    switchNetwork(chainId: string) {
        switchChain(this.appkitService.adapter.wagmiConfig, { chainId: Number(chainId) })
            .catch((error: unknown) => this.logger.warn('Wallet did not switch to the marketplace network', error));
    }

    redirectToHome(authFailed: Boolean = false) {
        if (authFailed) {
            // Navigate to home without forcing a full reload to avoid reconnect loops on mobile
            if (this.router.url !== '/') {
                this.router.navigate(['/']);
            }
            return;
        }
        // If not already at home, navigate there; otherwise no-op
        if (this.router.url !== '/') {
            this.router.navigate(['/']);
        }
    }


    /**
     * Checks user registration
     * @param walletAddress 
     */
    async checkUserRegistration(walletAddress: any) {
        // Skip if we're on a page that handles its own wallet authentication
        const authPages = ['/sign-in', '/sign-up', '/lend-register', '/borrow-register'];
        if (authPages.some(page => this.router.url.startsWith(page))) {
            return;
        }

        // On page refresh the wagmi connector restores the wallet before
        // /user/auth/me has resolved, so userState.user is momentarily null.
        // Wait for the session bootstrap before deciding whether to run the
        // challenge/verify flow — otherwise MetaMask re-prompts for signature
        // on every refresh for an already-authenticated user.
        await this.appAuthService.initializeSession();

        // If user is already authenticated with the same wallet, skip the challenge/verify flow
        const currentUser = this.userState.user;
        if (currentUser?._id && currentUser?.wallet_address?.toLowerCase() === walletAddress?.toLowerCase()) {
            this.pendingAccount = null;
            return;
        }

        try {
            const verifyRes = await this.walletAuthCoordinator.runWalletAuthChallenge(walletAddress);
            if (!verifyRes) {
                // Skipped because another auth flow is already in progress in this or another tab.
                this.pendingAccount = null;
                return;
            }

            const userDetails = verifyRes.data;

            // Sync the authenticated user into the shared state service
            this.user = Object.keys(userDetails).length > 0 ? userDetails : null;
            if (this.user) {
                const verifiedAccount = this.pendingAccount ?? this.account;
                this.appAuthService.syncAuthenticatedUserState(this.user, {
                    regulated: false,
                    fallbackAccount: verifiedAccount
                });
                this.account = verifiedAccount;
            }
            this.pendingAccount = null;

            // Verification popup logic
            isUserVerifiedAndValid(this.user, this.verificationModal, this.regulated);

            // navigate after login: to the shared link this tab was opened on when the page
            // bounced the logged-out visitor elsewhere, otherwise stay (or leave the bare root)
            const returnUrl = this.user ? this.authReturnUrl.consumeOpenedLink() : null;
            if (returnUrl && returnUrl !== this.router.url) {
                this.router.navigateByUrl(returnUrl);
            } else if (this.user && this.router.url === '/') {
                this.router.navigate(['/dashboard']);
            }
        } catch (error: any) {
            if (error?.message === 'Wallet not connected' || error?.code === 4001) {
                this.logger.debug('Wallet signature rejected or wallet disconnected');
                this.walletStateService.requireExplicitWalletReconnect();
                this.pendingAccount = null;
                this.account = this.userState.account ?? this.walletStateService.getWallet() ?? this.account;
                return;
            }

            this.toastr.error('Something went wrong try again later.');
        }
    }

    private shouldBlockWalletAutoAuth(walletAddress: string | null | undefined): boolean {
        if (!walletAddress || !this.walletStateService.getRequiresExplicitWalletReconnect()) {
            return false;
        }

        const authenticatedWallet = this.userState.account?.walletAddress;
        if (!authenticatedWallet) {
            return true;
        }

        return authenticatedWallet.toLowerCase() !== walletAddress.toLowerCase();
    }

    private handleWalletDisconnectState(): void {
        this.pendingAccount = null;

        if (this.shouldLogoutOnWalletDisconnect()) {
            void this.logout(true);
        }
    }

    private shouldLogoutOnWalletDisconnect(): boolean {
        if (this.logoutInProgress || this.regulated || !this.user?._id) {
            return false;
        }

        return this.isSelfCustodyWalletProvider(this.account?.walletProvider);
    }

    private isSelfCustodyWalletProvider(provider: string | null | undefined): boolean {
        return provider === 'metamask'
            || provider === 'walletconnect'
            || provider === 'io.metamask'
            || provider === 'walletConnect';
    }



    ngOnDestroy() {
        this.teardownResizeObserver();
        this.closePushnotification();
        if (this.regulated == false) {
            // this.unwatchAccount();
            // this.unwatchNetwork();
            this.connectObservable?.unsubscribe();
        }
        this.loaderObservable?.unsubscribe();
        this.searchKeywordObservable?.unsubscribe();
        this.socketService.disconnect();
        this.authenticationObservable?.unsubscribe();
        window.removeEventListener('popstate', this.popStateHandler);

        // Cleanup subscription
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
        // The backdrop lives on <body>, outside this component's view, so it
        // survives the component being torn down. Drop it here or the next screen
        // renders under a dim nothing can clear.
        this.removeOverlay();
        this.stopTokenBalancePolling();
    }

    /**
     * Searchs for nft
     * @param {string} keyWord
     */
    search(keyWord: string) {
        this.nftService.setSearchKeyword(keyWord);
        this.searchKeyword = keyWord;
        this.isSearch = false;
    }

    /**
     * Toggles the profile overlay and starts/stops the token balance polling.
     * When the overlay is shown, it calls getBalance(), startTokenBalancePolling() and getUserNftsCount().
     * When the overlay is hidden, it calls stopTokenBalancePolling().
     */
    addOverlay() {
        this.showProfile = !this.showProfile;
        this.logger.debug('Header profile menu toggled', { showProfile: this.showProfile })
        if (this.showProfile) {
            this.renderer.addClass(document.body, 'dropdown-open');
            this.getBalance();
            this.getUserNftsCount();
            this.getKycStatus();
        } else {
            this.removeOverlay();
        }
        this.syncTokenBalancePollingState();
    }

    private openProfileMenuFromDashboard(options?: ProfileMenuAction) {
        if (this.showProfile) {
            if (options?.action === 'addFunds' && this.regulated) {
                this.openTransakModal();
            }
            return;
        }

        this.getBalance();
        this.getUserNftsCount();
        this.getKycStatus();

        // Defer until after the triggering click event has fully bubbled.
        // Without this, the document:click HostListener fires on the same event
        // and immediately closes the dropdown (showProfile true → clickout closes it).
        setTimeout(() => {
            this.showProfile = true;
            this.renderer.addClass(document.body, 'dropdown-open');
            this.syncTokenBalancePollingState();
            if (this.profileDropdownToggle?.nativeElement) {
                bootstrap.Dropdown.getOrCreateInstance(this.profileDropdownToggle.nativeElement).show();
            }
            if (options?.action === 'addFunds' && this.regulated) {
                this.openTransakModal();
            }
        }, 0);
    }

    /**
     * Starts polling token balances every TOKEN_BALANCE_POLL_MS.
     * This function also prevents duplicate intervals from being created.
     */
    startTokenBalancePolling() {
        // Prevent duplicate intervals
        if (this.tokenBalanceInterval) return;

        // Initial fetch; reuses a recent read when the menu is reopened quickly.
        void this.getTokenBalance();

        this.tokenBalanceInterval = setInterval(() => {
            // A background tab (or one of several open tabs) has nobody looking at the menu.
            if (document.visibilityState === 'hidden') return;
            void this.getTokenBalance();
        }, TOKEN_BALANCE_POLL_MS);
    }

    /**
     * Stops polling token balance by clearing the interval.
     */
    stopTokenBalancePolling() {
        if (this.tokenBalanceInterval) {
            clearInterval(this.tokenBalanceInterval);
            this.tokenBalanceInterval = null;
        }
    }



    copyWalletAddress(msg: any) {
        this.clipboardService.copy(msg);
        this.toastr.success('Copied wallet address.');
    }

    getUserNftsCount() {
        if (!this.canLoadVerifiedUserData()) {
            this.nftCount = 0;
            return;
        }

        this.nftService.getUserNftsCount().subscribe({
            next: (response: any) => this.nftCount = response?.data?.no_of_user_nfts || 0
        })
    }

    getCurrencies() {
        if (!this.canLoadVerifiedUserData()) { return; }
        this.commonService.getCurrencies().subscribe({
            next: async (response: any) => {
                this.currencies = [...response.data.filter((currency: any) => !currency.is_deleted)];
                this.logger.debug('Loaded currencies for header', { count: this.currencies.length });
                console.log('Currencies loaded in header:', this.currencies);
                // The fresh currency objects carry no balance, so the cached read no longer applies.
                this.tokenBalanceFetchedAt = 0;
                if (this.isBalancePollingWanted()) {
                    void this.getTokenBalance(true);
                }
            },
            error: (error) => {
                this.toastr.error(error?.data?.message || "Something went wrong, try again later.");
            }
        })
    }

    /**
     * Refreshes every currency's balance with one batched read (CommonService.getTokenBalances).
     * - A read younger than BALANCE_CACHE_MS for the same wallet, network and currency list is
     *   reused unless `force` is set.
     * - Never runs two reads at once: a call made while one is in flight shares it, and a
     *   forced call queues one more read for when it finishes, so the result reflects the change
     *   that asked for it.
     */
    async getTokenBalance(force = false): Promise<void> {
        if (!this.account?.walletAddress || !this.currencies?.length) {
            return;
        }
        if (this.tokenBalanceFetch) {
            if (force) { this.tokenBalanceRefreshQueued = true; }
            return this.tokenBalanceFetch;
        }
        const key = this.tokenBalanceKey();
        if (!force && key === this.tokenBalanceFetchKey && Date.now() - this.tokenBalanceFetchedAt < BALANCE_CACHE_MS) {
            return;
        }

        this.tokenBalanceFetch = (async () => {
            try {
                const balances = await this.commonService.getTokenBalances(
                    this.account,
                    this.currencies.map((currency: any) => currency.address)
                );
                // The wallet, network or currency list changed mid-read: drop the stale result.
                if (key !== this.tokenBalanceKey()) { return; }
                this.currencies.forEach((currency: any) => {
                    const balance = balances[String(currency.address).toLowerCase()];
                    if (balance !== undefined) { currency.balance = balance; }
                });
                this.currencies = [...this.currencies].sort((a, b) => (b.balance || 0) - (a.balance || 0));
                this.tokenBalanceFetchKey = key;
                this.tokenBalanceFetchedAt = Date.now();
            } catch (error) {
                this.logger.warn('Failed to read token balances for header', error);
            } finally {
                this.tokenBalanceFetch = null;
                if (this.tokenBalanceRefreshQueued) {
                    this.tokenBalanceRefreshQueued = false;
                    void this.getTokenBalance(true);
                }
            }
        })();
        return this.tokenBalanceFetch;
    }

    private walletBalanceKey(): string {
        return `${String(this.account?.walletAddress || '').toLowerCase()}:${this.account?.networkId ?? ''}`;
    }

    private tokenBalanceKey(): string {
        const addresses = (this.currencies || []).map((currency: any) => String(currency.address).toLowerCase()).sort();
        return `${this.walletBalanceKey()}:${addresses.join(',')}`;
    }

    private isBalancePollingWanted(): boolean {
        return this.showProfile || this.isUsdcModalOpen;
    }

    /**
     * The USDC modal moved funds (a withdrawal was accepted). Re-read both balances now
     * instead of waiting out the cache window.
     */
    onFundsChanged(): void {
        void this.getBalance(true);
        void this.getTokenBalance(true);
    }

    getNotifications() {
        if (!this.canLoadVerifiedUserData()) {
            this.resetVerifiedUserScopedUi();
            return;
        }

        this.isNotificationLoader = true;
        this.notificationPage = 1;
        this.hasMoreNotifications = true;
        this.isNotificationLoadingMore = false;
        this.notificationService.getNotifications(this.user._id, this.notificationPage, this.notificationLimit).subscribe({
            next: (response: any) => {
                this.setNotifications(response.data);
            },
            error: async (error) => {
                this.isNotificationLoader = false;
                if (this.accountService.shouldTreatUnauthorizedAsSessionExpiry(error)) {
                    error.shortMessage = "You’ve been logged out due to inactivity.";
                    await this.accountService.updateAuthentication(false);
                }
                this.toastr.error(error?.error?.data?.message || error?.data?.message || error.shortMessage || "Something went wrong, try again later.");
            }
        })
    }

    setNotifications(data: any) {
        const newResults = data.results || [];
        // this.notifications = newResults;

        this.notificationCount = Number(data.unread_notification_count) || 0;
        // Set after the count, which it lowers for any winner's own "Bid closed" it leaves out.
        this.notifications = this.filterOwnBidClosedNotifications(newResults);
        this.notifications?.forEach((notification: any) => {
            notification.timeDiff = dayjs(notification.createdAt).from(dayjs());
            if (notification.timeDiff === 'in a few seconds') notification.timeDiff = 'a few seconds ago';
            notification.image = notification?.updateData?.image;
        })
        this.checkUnreadNotifications();
        this.notificationPage = 1;
        this.hasMoreNotifications = newResults.length >= this.notificationLimit;
        this.isNotificationLoader = false;
    }

    /**
     * Loads more notifications when the user scrolls to the bottom of the notification list.
     * Prevents multiple simultaneous loads and checks if there are more notifications to load before making the API call.
     * On success, appends the new notifications to the existing list and updates the unread count and loading state.
     * On error, displays an error message.
     */
    loadMoreNotifications() {
        if (!this.canLoadVerifiedUserData() || this.isNotificationLoadingMore || !this.hasMoreNotifications) {
            return;
        }

        this.isNotificationLoadingMore = true;
        const nextPage = this.notificationPage + 1;

        this.notificationService.getNotifications(this.user._id, nextPage, this.notificationLimit).subscribe({
            next: (response: any) => {
                const newResults = response.data?.results || [];
                if (newResults.length > 0) {
                    this.notificationPage = nextPage;
                    // Format time difference and image for new notifications
                    newResults.forEach((notification: any) => {
                        notification.timeDiff = dayjs(notification.createdAt).from(dayjs());
                        if (notification.timeDiff === 'in a few seconds') notification.timeDiff = 'a few seconds ago';
                        notification.image = notification?.updateData?.image;
                    });
                    
                    // Append new notifications to the existing list
                    // this.notifications = [...this.notifications, ...newResults];
                }

                if (response.data?.unread_notification_count !== undefined) {
                    this.notificationCount = Number(response.data.unread_notification_count) || 0;
                }
                // After the count, which it lowers for any winner's own "Bid closed" it leaves out.
                // newResults.length below still reads the raw page size for the end-of-list check.
                if (newResults.length > 0) {
                    this.notifications = [...this.notifications, ...this.filterOwnBidClosedNotifications(newResults, this.notifications)];
                }
                this.checkUnreadNotifications();

                // If the returned results are fewer than the limit, we've reached the end
                if (newResults.length < this.notificationLimit) {
                    this.hasMoreNotifications = false;
                }

                this.isNotificationLoadingMore = false;
            },
            error: async (error) => {
                this.isNotificationLoadingMore = false;
                if (this.accountService.shouldTreatUnauthorizedAsSessionExpiry(error)) {
                    error.shortMessage = "You’ve been logged out due to inactivity.";
                    await this.accountService.updateAuthentication(false);
                }
                this.toastr.error(error?.error?.data?.message || error?.data?.message || error.shortMessage || "Something went wrong, try again later.");
            }
        });
    }

    /**
     * Event handler for the scroll event on the notification list. Checks if the user has scrolled near the bottom of the list and triggers loading more notifications if necessary.
     */
    onNotificationScroll(event: any) {
        const element = event.target;
        // Check if user scrolled near the bottom (within 50px of the bottom)
        const threshold = 50;
        const atBottom = element.scrollHeight - element.scrollTop - element.clientHeight < threshold;

        if (atBottom) {
            this.loadMoreNotifications();
        }
    }

    readNotification(notification: any) {
        if (!this.canLoadVerifiedUserData()) { return; }
        if (notification.read === 0) {
            this.notificationService.readNotification({ notifications: [notification._id] }).subscribe({
                next: (response: any) => {
                    this.setNotifications(response.data);
                    this.redirectNotifications(notification);
                },
                error: (error) => this.toastr.error(error?.data?.message || "Something went wrong, try again later.")
            })
        } else this.redirectNotifications(notification);
    }

    /**
     * Redirects the user based on the type of notification
     * @param notification The notification object to redirect based on
     */
    redirectNotifications(notification: any) {
        // Bell rows skip the push card's canRedirect check. Events 23/32/38/42/52/54 and the admin
        // collection-delete row (saved as event 74) carry no target and would open `.../undefined`.
        // NEW_ITEM_ADDED goes to /my-wallet and needs none.
        if (notification?.event_type !== NotificationEvent.NEW_ITEM_ADDED && !this.hasNotificationTarget(notification)) {
            return;
        }
        if (KYC_NOTIFICATION.includes(notification.event_type)) {
            // this.addOverlay();
            // Open, never toggle: addOverlay closes an already-open panel, never calls Bootstrap's
            // show(), and the same click's document:click (clickout) would close it again.
            this.openProfileMenuFromDashboard();
        }
        if (DEPOSIT_NOTIFICATIONS.includes(notification.event_type)) {
            // The deposit tracker, not an item page: until the deposit is minted there is no
            // NFT to open, and the timeline is what the notification is telling them about.
            this.router.navigate(['/my-deposits']);
            return;
        }
        if (OTHER_NOTIFICATONS.includes(notification.event_type)) {
            if (notification.event_type == NotificationEvent.REFINANCE_REQUEST_CREATED) {
                this.router.navigate([`/lending-detail/${notification?.updateData?.loan_id}`]);
                return;
            }
            if (notification.event_type == NotificationEvent.NEW_ITEM_ADDED) {
                this.router.navigate([`/my-wallet`]);
                return;
            }
            if (notification?.updateData?.id) {
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    this.router.navigate([`/lazy-mint/${notification?.updateData.id}`])
                });
            } else {
                const focus = this.getNftDetailFocus(notification.event_type);
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    this.router.navigate(
                        [`/nft-detail/${notification?.updateData?.collection_address}/${notification?.updateData?.token_id}`],
                        focus ? { queryParams: { focus } } : {}
                    )
                });
            }
        }
        if (BORROWER_NOTIFICATIONS.includes(notification.event_type)) {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([`borrow-detail/${notification?.updateData?.id}`]);
            });
        }
        if (LENDER_NOTIFICATIONS.includes(notification.event_type)) {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([`lending-detail/${notification?.updateData?.id}`]);
            });
        }

        if (BULK_OPEN_LOAN_OFFER_NOTIFICATION.includes(notification.event_type)) {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([`offer-loans/details/${notification?.updateData?.id}`]);
            })
        }
        if (FUND_NOTIFICATION.includes(notification.event_type)) {
            const url = getExplorerTransactionUrl(notification?.updateData?.id, this.account?.chainId);
            window.open(url, '_blank');
        }
        if (BORROWANDLEND.includes(notification.event_type) || SYNDICATELEND.includes(notification.event_type)) {
            this.router.navigate([`lending-detail/${notification?.updateData?.id}`]);
        }
        if (RESELLNOTIFICATION.includes(notification.event_type)) {
            this.router.navigate([`resell-loan/${notification?.updateData?.id}`]);
        }
        if (this._notification.LOAN_LENDER_CHANGED == notification.event_type) {
            this.router.navigate([`borrow-detail/${notification?.updateData?.id}`]);
        }
    }

    /**
     * The NFT details section a notification should open on: bid events go to the bids list,
     * loan offer events to the loan offers list. Everything else opens the page as before.
     */
    private getNftDetailFocus(eventType: NotificationEvent): 'bids' | 'loan-offers' | null {
        if (BID_FOCUS_NOTIFICATIONS.includes(eventType)) return 'bids';
        if (LOAN_OFFER_FOCUS_NOTIFICATIONS.includes(eventType)) return 'loan-offers';
        return null;
    }

    async getKycStatus() {
        if (!this.canLoadVerifiedUserData()) {
            this.kycStatus = {};
            return;
        }

        const kycStatus: any = await this.accountService.getKycStatus();
        this.kycStatus = kycStatus?.data
    }

    /**
     * Collects the ids of every unread notification, not just the pages currently loaded in the UI.
     * The list endpoint has no unread-only filter, so we walk the pages until we have gathered as many
     * unread ids as the server reports unread, or until the pages run out.
     */
    private async fetchAllUnreadNotificationIds(): Promise<string[]> {
        const unreadIds: string[] = [];
        let page = 1;

        while (page <= this.READ_ALL_MAX_PAGES) {
            const response: any = await firstValueFrom(
                this.notificationService.getNotifications(this.user._id, page, this.READ_ALL_FETCH_LIMIT)
            );
            const results = response?.data?.results || [];
            if (!results.length) break;

            results.forEach((notification: any) => {
                if (notification.read === 0) unreadIds.push(notification._id);
            });

            // Stop once we have every unread notification the server knows about. The list endpoint
            // filters some notifications out, so a short page does not reliably mean the last page.
            const unreadCount = Number(response?.data?.unread_notification_count) || 0;
            if (unreadIds.length >= unreadCount) break;

            page++;
        }

        return unreadIds;
    }

    async readAllNotification() {
        if (!this.canLoadVerifiedUserData()) { return; }
        this.isNotificationLoader = true;
        try {
            const unreadIds = await this.fetchAllUnreadNotificationIds();
            if (!unreadIds.length) {
                this.getNotifications();
                return;
            }

            const response: any = await firstValueFrom(this.notificationService.readNotification({ notifications: unreadIds }));
            this.setNotifications(response.data);
        } catch (error: any) {
            this.isNotificationLoader = false;
            if (this.accountService.shouldTreatUnauthorizedAsSessionExpiry(error)) {
                error.shortMessage = "You’ve been logged out due to inactivity.";
                await this.accountService.updateAuthentication(false);
            }
            this.toastr.error(error?.error?.data?.message || error?.data?.message || error.shortMessage || "Something went wrong, try again later.");
        }
    }


    /**
     * Fetches cart details
     * 
     * Subscribes to the cart service to fetch the cart details.
     * If authentication fails, it updates the authentication status to false.
     * If any other error occurs, it displays a toast with the error message.
     */
    getCartDetails() {
        if (!this.canLoadVerifiedUserData()) {
            this.cartDetails = [];
            this.cartCount = 0;
            return;
        }

        this.cartService.getCart().subscribe({
            next: (response: any) => {
                this.cartDetails = response.data;
                this.cartCount = this.cartDetails.length;
            },
            error: async (error) => {
                if (this.accountService.shouldTreatUnauthorizedAsSessionExpiry(error)) {
                    error.shortMessage = "You’ve been logged out due to inactivity.";
                    await this.accountService.updateAuthentication(false);
                }
                this.toastr.error(error?.error?.data?.message || error?.data?.message || error.shortMessage || "Something went wrong, try again later.");
            }
        })
    }

    /**
     * Gets recent search
     */
    getRecentSearch() {
        if (this.user?._id && this.canLoadVerifiedUserData()) {
            this.nftService.getRecentSearch(this.user?._id).subscribe((response: any) => {
                this.recentSearch = response.data;
            })
        }
    }

    /**
     * Clicks search
     */
    clickSearch() {
        this.isSearch = true;
        this.isSearchLoading = true;
    }

    // @HostListener('document:click', ['$event'])
    // clickout(event: MouseEvent) {
    //     if (!this.elementRef.nativeElement.contains(event.target)) {
    //         this.isSearch = false;
    //         this.isSearchLoading = false;
    //         if (this.showProfile) {
    //             this.closeProfile();
    //             this.stopTokenBalancePolling(); // STOP polling
    //           }
    //     }
    // }

    @HostListener('document:click', ['$event'])
    clickout(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const clickedInsideSearch = !!this.searchContainer?.nativeElement?.contains(target);

        if (!clickedInsideSearch && this.isSearch) {
            this.isSearch = false;
            this.isSearchLoading = false;
        }

        const clickedProfileBtn = target.closest('.onboard-dropdown');
        const clickedDropdownMenu = target.closest('.dropdown-menu');

        // ❌ DO NOTHING if click is inside dropdown menu or profile button
        if (clickedProfileBtn || clickedDropdownMenu) {
            return;
        }

        // ✅ Outside click
        if (this.showProfile) {
            this.showProfile = false;
            this.removeOverlay();
            this.syncTokenBalancePollingState();
        }
    }

    closeProfile() {
        this.showProfile = false;
        // The backdrop is driven by the body class, not by `showProfile`, so it has
        // to come off here too — otherwise closing this way leaves the page dimmed.
        this.removeOverlay();
        // Bootstrap keeps its own open state (`.show` on the menu), separate from
        // `showProfile`; without hiding it the panel stays on screen over the next page.
        this.hideProfileDropdowns();
        this.syncTokenBalancePollingState();
    }

    /**
     * Opens the KYC screen from the profile panel (Verify, Reverify and expired-KYC
     * actions). Remembers the current route for the KYC return flow, then closes the
     * panel and its overlay so the KYC screen renders unobstructed. Clicks inside the
     * panel never reach the outside-click handler, so it is closed here explicitly.
     */
    goToKyc(): void {
        this.setRoute();
        this.closeProfile();
    }

    /**
     * Hides the Bootstrap dropdown behind the desktop and mobile profile toggles.
     * Uses getInstance (not getOrCreateInstance) so a toggle that was never opened is left alone.
     */
    private hideProfileDropdowns(): void {
        if (typeof bootstrap === 'undefined') return;
        for (const toggle of [this.profileDropdownToggle, this.profileDropdownToggleMobile]) {
            const element = toggle?.nativeElement;
            if (element) {
                bootstrap.Dropdown.getInstance(element)?.hide();
            }
        }
    }


    /**
     * push notiifcation close
     * With a push: closes that card (its × or its own 5s timer) and, once its leave animation has
     * finished, shows the oldest queued notification. Without one: clears every card and the queue.
     */
    closePushnotification(push?: PushNotificationItem) {
        // if (this.pushNotificationTimeout) {
        //     clearTimeout(this.pushNotificationTimeout);
        //     this.pushNotificationTimeout = null;
        // }
        // this.isNotification = false;
        // this.notification = {};
        // this.pushNotificationMeta = null;
        const closing = push ? [push] : this.pushNotifications;
        // A card closed twice (timer firing as it is clicked) must not pull a second one off the queue.
        const wasVisible = !!push && this.pushNotifications.includes(push);
        closing.forEach((item) => item.timeout && clearTimeout(item.timeout));
        this.pushNotifications = this.pushNotifications.filter((item) => !closing.includes(item));

        if (!push) {
            this.pushNotificationQueue = [];
            this.clearPushNotificationLeaveTimeout();
        } else if (wasVisible) {
            // const next = this.pushNotificationQueue.shift();
            // if (next) this.displayPushNotification(next);
            // Showing the next card straight away overlapped it with the one still sliding out.
            this.clearPushNotificationLeaveTimeout();
            this.pushNotificationLeaveTimeout = setTimeout(() => this.showNextPushNotification(), this.PUSH_NOTIFICATION_LEAVE_DURATION);
        }

        this.isNotification = this.pushNotifications.length > 0;
        if (!this.isNotification) this.notification = {};
    }

    /** Runs after a closed card has fully left the screen: shows the oldest queued notification. */
    private showNextPushNotification() {
        this.pushNotificationLeaveTimeout = null;
        if (this.pushNotifications.length >= this.MAX_VISIBLE_PUSH_NOTIFICATIONS) return;
        const next = this.pushNotificationQueue.shift();
        if (!next) return;
        this.displayPushNotification(next);
        this.isNotification = true;
        this.notification = next.notification;
    }

    private clearPushNotificationLeaveTimeout() {
        if (this.pushNotificationLeaveTimeout) clearTimeout(this.pushNotificationLeaveTimeout);
        this.pushNotificationLeaveTimeout = null;
    }

    // "View ..." action on the push card: same redirect as clicking the bell row.
    // View action removed from the push card; the bell row still handles the redirect.
    // viewPushNotification() {
    //     const notification = this.notification;
    //     this.closePushnotification();
    //     notification?._id && this.readNotification(notification);
    // }

    setRoute() {
        this.webStorageService.setItem('previousRoute', this.router.url)
        this.showMenu = false;
    }

    expandCollapse(event: any, notification: any) {
        event.stopPropagation();
        notification.isExpand = !notification.isExpand;
    }

    isHtmlFile(url: string): boolean {
        return url ? url.split('.').pop() === 'html' : false;
    }
    getAdminAnnouncement() {
        this.announce.getAnnouncement().subscribe({
            next: (response: IApiResponse) => {
                this.announceData = response.data;
                if (this.announceData.enabled == true) {
                    document.body.classList.add('enable-status-scroll')
                }
                else {
                    document.body.classList.add('disable-status-scroll')
                }
            },
            error: (response: IApiResponse) => {
                this.logger.warn('Failed to load admin announcement');

            }
        })
        this.updateAnnouncementHeight();
    }


    private setupResizeObserver() {
        if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => {
                this.updateAnnouncementHeight();
                this.cdref.detectChanges();
            });

            if (this.announcementContainer) {
                this.resizeObserver.observe(this.announcementContainer.nativeElement);
            }
        }
    }

    private teardownResizeObserver() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    get _notification(): typeof NotificationEvent {
        return NotificationEvent
    }
    checkUnreadNotifications() {
        // Derived from the server-side unread count, not the loaded page, since
        // unread notifications can exist beyond the pages fetched so far.
        this.hasUnreadNotifications = this.notificationCount > 0;
    }


    openEmailMenu() {
        if (this.shouldForceEmailVerificationModal()) {
            this.syncVerificationModalState();
            return;
        }

        this.showMailVerificationMenu = false;
        this.verificationModal?.show();
    }

    /**
     * Opens profile edit model
     */
    openProfileEditModel() {
        this.profileEditModel?.show();
    }

    /**
     * Handles the extraction and processing of a search value from URL parameters.
     * @param urlParams The URL query string containing filter parameters.
     * @param callBack A function to call with the extracted search value.
     */
    async handleSearchValue(urlParams: string, callBack: (value: string) => void) {
        const decodedUrlParams = decodeURIComponent(urlParams);
        let searchQuery = '';
        const urlSegments = decodedUrlParams.split('/?filter/');

        if (urlSegments.length !== 1) {
            const queryParams = urlSegments[1].split('&');
            const validFilters = this.filterSyncUrlHelper.removeUnwantedParams(queryParams);

            if (validFilters[0].includes('key')) {
                searchQuery = validFilters[0].split('key=')[1];
                callBack(searchQuery);
                return;
            }
        }

        callBack(searchQuery);
    }


    get routerCheck() {
        const path = this.router.url.split('?')[0].split('#')[0];
        if (
            path === '/all-assets' ||
            path.startsWith('/all-assets/') ||
            decodeURIComponent(this.router.url).includes('/?filter/')
        ) {
            return true
        } else {
            this.searchKeyword = ''
            return false
        }
    }



    /**
     * Add the event listener for the browser back button detection.
     * @param type 
     */
    browserBackButtonEvent(type: number) {
        if (type == 1) {
            window.addEventListener('popstate', this.popStateHandler)
        }
    }

    /**
     * Sets listner connect wallet
     * Here we declare for if the user swith their platform from custody to self-custodial the instence not appear properly.
     */

    wagmiConfigAdopter!: Config
    wagmiInstance: any;
    wagmiMetaData: any;
    appKitModal: any
    async setListnerConnectWallet() {
        const addSuppoortedNetworks: any = environment.DEFAULT_NETWORK == '137' ? polygon : polygonAmoy
        this.wagmiMetaData = {
            name: 'Real World',
            description: 'RealWorld.fi - Marketplace',
            url: environment.WEB_SITE_URL,
            icons: ['https://avatars.githubusercontent.com/u/37784886']
        }
        const wagmiAdapter: any = new WagmiAdapter({
            projectId: environment.WALLET_CONNECT_PROJECT_ID, networks: [addSuppoortedNetworks], chains: [addSuppoortedNetworks]
        })
        this.wagmiConfigAdopter = wagmiAdapter.wagmiConfig
        this.wagmiInstance = wagmiAdapter
        this.appKitModal = await createAppKit({
            adapters: [this.wagmiInstance],
            networks: [addSuppoortedNetworks],
            metadata: this.wagmiMetaData,
            projectId: environment.WALLET_CONNECT_PROJECT_ID,
            features: {
                analytics: false,
                socials: false,
                email: false
            },
            themeVariables: {
                "--w3m-color-mix": "#076939ff",
                "--w3m-color-mix-strength": 40,
                "--w3m-accent": "#076939ff",
            },
            enableNetworkSwitch: false,
            enableReconnect: true,
            allowUnsupportedChain: false
        })
        // Watch for account changes
        watchAccount(wagmiAdapter.wagmiConfig, {
            onChange: async (account: any) => {
                if (account.isConnected) {
                    const isSupportedNetwork = environment.DEFAULT_NETWORK == account.chainId.toString() ? false : true
                    const new_wagmi_store =
                    {
                        state: {
                            data: {
                                account: account.address,
                                address: account.address,
                                network: (environment as any)[environment.DEFAULT_CHAIN].CHAIN_NETWORK,
                                chainId: account.chainId,
                                provider: (environment as any)[environment.DEFAULT_CHAIN].CHAIN_NETWORK,
                                chain: {
                                    id: account.chainId.toString(),
                                    unsupported: isSupportedNetwork
                                }
                            }
                        }
                    }
                    this.walletStateService.setRegulated(false);
                    this.walletStateService.setWagmiStore(new_wagmi_store)
                    this.walletStateService.setWagmiConnected(true)

                    setTimeout(() => {
                        this.setAccount();
                    }, 1000);
                }
            }
        });

        // Watch for connection (network) changes
        watchConnections(wagmiAdapter.wagmiConfig, {
            onChange: (connections) => {
                this.account = this.userState.account ?? this.account;
                if (Array.isArray(connections) && connections.length == 0) {
                    this.logout()
                } else {
                    setTimeout(() => {
                        this.setAccount();
                    }, 1000);
                }
            }
        })
        //We need to change the connector and use the same connector for all @wagmi and core function's
        await reconnect(wagmiAdapter.wagmiConfig).then(async (res: any) => { //this was used to retrive the Appkit-account-button state.
            this.logger.debug('Account connector reconnected for header');
        })
        await reconnect(this.appkitService.adapter.wagmiConfig) // This one is used for @wagmi/core connectors 
    }

    /**
 * Profiles image change
 * @param {any} event 
 */
    profileImageChange(event: any) {
        if (!this.canLoadVerifiedUserData()) { return; }
        let extension = event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('.'));
        if (!['.png', '.jpg', '.jpeg'].includes(extension.toLowerCase())) {
            this.toastr.error(extension.toLowerCase() + ' file format not supported.');
        }
        else {
            this.profileLoader = true;
            this.commonService.profileImageUpload(event.target.files[0]).subscribe({
                next: (response: any) => {
                    this.imageUploadProcess(response['data'].file[0].Url);
                    this.profileLoader = false;
                }, error: (error: HttpErrorResponse) => {
                    this.toastr.error(error.error.message);
                    this.profileLoader = false;
                }
            })
        }
    }

    /**
     * Images upload process
     * @param {string} url 
     */
    imageUploadProcess(url: string) {
        let data = {
            profile_image: url
        }
        this.commonService.updateUsers(data).subscribe({
            next: (response: any) => {
                this.profileurl = response.data.profile_image;;
                this.toastr.success('Profile image updated successfully');
            }, error: (error: HttpErrorResponse) => {
                this.toastr.error(error.error.message);
            }
        })
    }

    /**
     * Handles oauth state
     * @param [isLogout] 
     */
    handleOauthState(isLogout: boolean = false) {
        this.authService.authState.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (user) => {
            if (user) {
                await this.commonService._handleOauthLogin(user);
                this._handleGoogleOneTapClose()
            }
        });
    }

    /**
     * Handles data
     * @param data 
     */
    handleData(result: any) {

        const { data, updateKey } = result
        if (data) {
            let userDetails: any = this.user
            if (updateKey == 'privacy_policy') {
                userDetails['is_policy_accepted'] = data.is_policy_accepted;
            } else {
                userDetails['display_name'] = data.display_name;
                // Names come back only when the profile edit was allowed to change them
                if (data.first_name !== undefined) userDetails['first_name'] = data.first_name;
                if (data.last_name !== undefined) userDetails['last_name'] = data.last_name;
                if (data.name !== undefined) userDetails['name'] = data.name;
            }
            this.webStorageService.setLocalStorage('user', JSON.stringify(userDetails))
            this.logger.debug('Loaded user details for header', { hasUserDetails: !!userDetails });

            this.user = userDetails
            // Push into shared state so user$ subscribers see the new name, not just this header
            this.userState.setUser(userDetails)
        }
    }

    /**
     * Opens transak modal
     * @param data 
     */
    openTransakModal() {
        this.usdcModalInitialTab = 'add';
        this.transakModal?.show();
    }

    private canLoadVerifiedUserData(user: any = this.user): boolean {
        return canAccessVerifiedUserApis(user, this.regulated);
    }

    private shouldForceEmailVerificationModal(user: any = this.user): boolean {
        return user?.email_verified === false;
    }

    private syncVerificationModalState(user: any = this.user): void {
        if (!this.shouldForceEmailVerificationModal(user) || !this.verificationModal) {
            return;
        }

        this.showMailVerificationMenu = true;

        if (!this.verificationModal.isShown) {
            this.verificationModal.show();
        }
    }

    /**
     * Gate the verification modal close: the modal is the email-verification
     * barrier, so it may only be dismissed once the user is no longer blocked
     * (email verified, and valid for self-custody). Any other close attempt
     * (child close events, page-refresh re-show) keeps it open — preventing the
     * "refresh dismisses the popup → sign → bypass verification" exploit.
     * Reads the freshest userState so a successful verify isn't locked out by
     * a stale local `this.user`.
     */
    handleVerificationModalClose(): void {
        const latestUser = this.userState.user ?? this.user;
        if (isVerificationBlockedUser(latestUser, this.regulated)) {
            this.verificationModal?.show();
            return;
        }
        this.verificationModal?.hide();
    }

    private resetVerifiedUserScopedUi(): void {
        this.isNotificationLoader = false;
        this.notifications = [];
        this.notificationCount = 0;
        this.hasUnreadNotifications = false;
        this.cartDetails = [];
        this.cartCount = 0;
        this.profileurl = undefined;
        this.userDetails = undefined;
        this.introducerOverview = null;
    }

    /** Loads the profile menu's Introducer earnings entry. A failure just leaves the entry hidden. */
    private getIntroducerOverview(): void {
        this.introducerService.getOverview().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (res) => {
                this.introducerOverview = res?.data?.is_introducer ? res.data : null;
            },
            error: () => {
                this.introducerOverview = null;
            },
        });
    }

    get introducerEarnedLabel(): string {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(this.introducerOverview?.total_earned || 0);
    }

    openIntroducerEarnings(): void {
        this.closeProfile();
        this.router.navigate(['/introducer-earnings']);
    }


    /**
     * Opens the withdraw fund modal.
     * If the user has an approved withdrawal wallet address, it will show the modal directly.
     * If the user does not have an approved withdrawal wallet address, it will first get the withdrawal status update and then show the modal.
     */
    async openWithdrawFundModal() {
        if (!this.canShowWithdrawButton) { return; }
        if (!this.canLoadVerifiedUserData()) { return; }
        if (this.currencies.length > 0) {
            await this.getTokenBalance();
        }

        const withdrawlWalletAddress = this.user?.withdrawal_wallet_address ? this.user?.withdrawal_wallet_address : this.webStorageService.getLocalStorage('withdrawal_wallet_address');
        if (withdrawlWalletAddress == null || withdrawlWalletAddress == undefined) {
            this.getWithdrawalStatusUpdate();
        }
        this.usdcModalInitialTab = 'withdraw';
        this.transakModal?.show();
    }

    onUsdcModalShown() {
        this.isUsdcModalOpen = true;
        this.syncTokenBalancePollingState();
    }

    onUsdcModalHidden() {
        this.isUsdcModalOpen = false;
        this.syncTokenBalancePollingState();
    }

    /**
     * Handles google one tap close
     */
    _handleGoogleOneTapClose() {
        if (window?.google && window?.google?.accounts && window?.google?.accounts?.id) {
            window.google.accounts.id.cancel()
            window.google.accounts.id.disableAutoSelect();
        }
    }
    async showConnectModal() {
        await this.appKitModal.open({ view: 'Account' })
    }



    /**
     * Subscribes to socket service to listen for withdrawal status updates.
     * If the withdrawal status is approved (status === 1), it will add/update the wallet address.
     * If the withdrawal status is not approved (status !== 1), it will remove the wallet address.
     */
    getWithdrawalStatusUpdate() {
        this.socketService.getWithdrawalStatusUpdate()
            .pipe(take(1), takeUntilDestroyed(this.destroyRef))
            .subscribe((res) => {

            const status = res?.data?.approval_status;
            const address = res?.data?.withdrawal_wallet_address;

            if (status === 1) {
                // Add/update wallet address
                this.updateUserKey('withdrawal_wallet_address', address);
            } else {
                // Remove wallet address
                this.updateUserKey('withdrawal_wallet_address', null, true);
            }

        });
    }


    /**
     * Updates a standalone key and a key inside the user object
     * @param key the key to update
     * @param value the value to update the key with
     * @param remove if true, removes the key instead of updating it
     */
    updateUserKey(key: string, value: any, remove: boolean = false) {

        // Update standalone key
        if (remove) {
            this.webStorageService.removeItem(key);
        } else {
            this.webStorageService.setLocalStorage(key, value);
        }

        // Update inside user object
        const userStr = this.webStorageService.getLocalStorage('user');
        if (!userStr) return;

        const user = JSON.parse(userStr);

        if (remove) {
            delete user[key];
        } else {
            user[key] = value;
        }

        this.webStorageService.setLocalStorage('user', JSON.stringify(user));
    }

    /**
     * Opens the my cart modal
     */
    openmyCartModal() {
        this.myCartModal?.show();
    }

    /**
    * Gets value
    * @param value 
    * @returns value 
    */
    getValue(value: string): string {
        return decodeHtmlEntities(value);
    }

    formatProfileCurrencyAmount(
        value: number | string | null | undefined,
        symbol: string = '$'
    ): string {
        const safeSymbol = symbol && symbol.trim() && symbol !== '-' ? symbol : '$';

        if (value === null || value === undefined || value === '') {
            return '-';
        }

        const num = typeof value === 'string'
            ? Number(value.split(' ')[0])
            : Number(value);

        if (isNaN(num) || num === 0) {
            return '-';
        }

        const truncatedValue = Math.floor(num * 100) / 100;
        const hasDecimals = truncatedValue % 1 !== 0;
        const formattedValue = truncatedValue.toLocaleString('en-US', {
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: 2
        });

        return `${safeSymbol}${formattedValue}`;
    }


    removeOverlay() {
        this.renderer.removeClass(document.body, 'dropdown-open');
    }

    private syncTokenBalancePollingState() {
        if (this.isBalancePollingWanted()) {
            this.startTokenBalancePolling();
            return;
        }

        this.stopTokenBalancePolling();
    }

    /**
     * Hides the privacy policy modal and removes the modal-open class from the body, as well as all modal-backdrop elements.
     * This is a safety cleanup, as the modal-open class can interfere with other modals.
     */
    onClosePrivacyPolicy() {
        this.privacyPolicyModal?.hide();
        this.privacyPolicyStatus = false;

        // SAFETY CLEANUP (important)
        document.body.classList.remove('modal-open');
        document.querySelectorAll('.modal-backdrop')
            .forEach(el => el.remove());
    }

}
